import React, { useState } from 'react';
import { PRODUCTOS } from '../data/productos';

const CATEGORIAS = ['Todos', ...Array.from(new Set(PRODUCTOS.map((p) => p.categoria)))];

export default function Landing() {
  const [categoria, setCategoria] = useState('Todos');

  function getSello(producto) {
    return (
      <div className="card__seal" aria-hidden="true">
        {producto.categoria.slice(0, 1)}
      </div>
    );
  }

  function getTarjeta(producto) {
    return (
      <article className="card" key={producto.id}>
        {producto.imagen ? <img alt="" className="card__img" src={producto.imagen} /> : null}
        <div className="card__top">
          {producto.imagen ? null : getSello(producto)}
          <span className="card__cat">{producto.categoria}</span>
        </div>
        <h3 className="card__name">{producto.nombre}</h3>
        <p className="card__dato">
          <span className="card__label">El dato</span>
          {producto.dato}
        </p>
        <a
          className="card__btn"
          href={producto.link}
          rel="sponsored noopener noreferrer"
          target="_blank"
        >
          Ver en Mercado Libre
        </a>
      </article>
    );
  }

  function getGrilla(tarjetas) {
    if (tarjetas.length === 0) {
      return <p className="vacio">No hay datos en esta categoría.</p>;
    }
    return <div className="grid">{tarjetas}</div>;
  }

  const visibles = PRODUCTOS.filter((producto) => {
    return categoria === 'Todos' || producto.categoria === categoria;
  });

  const chips = CATEGORIAS.map((nombre) => {
    const activo = nombre === categoria;
    const clase = activo ? 'chip chip--on' : 'chip';
    return (
      <button
        aria-pressed={activo}
        className={clase}
        key={nombre}
        onClick={() => setCategoria(nombre)}
        type="button"
      >
        {nombre}
      </button>
    );
  });

  const tarjetas = visibles.map((producto) => getTarjeta(producto));

  return (
    <main>
      <p className="ribbon">
        No vendemos el producto · Si comprás, cobramos comisión · Sin costo extra
      </p>

      <header className="nav">
        <a className="nav__brand" href="#inicio">
          <img alt="" className="nav__logo" src="/logo.png" />
          <span className="nav__name">El buen dato</span>
        </a>
        <nav className="nav__links" aria-label="Principal">
          <a className="nav__link" href="#datos">
            Datos
          </a>
          <a className="nav__link" href="#como">
            Cómo funciona
          </a>
        </nav>
      </header>

      <section className="hero" id="inicio">
        <div className="hero__glow" aria-hidden="true" />
        <div className="hero__inner">
          <img alt="El buen dato" className="hero__logo" src="/logo.png" />
          <p className="hero__kicker">Mercado Libre · afiliados</p>
          <h1 className="hero__title">El dato justo para comprar bien</h1>
          <p className="hero__lead">
            Elegimos productos de Mercado Libre y te dejamos el link. Comprás allá, al
            mismo precio. Nosotros no vendemos: si se concreta, cobramos una comisión.
          </p>
          <div className="hero__actions">
            <a className="btn" href="#datos">
              Ver los datos
            </a>
            <a className="btn btn--ghost" href="#como">
              Cómo funciona
            </a>
          </div>
        </div>
      </section>

      <section className="trust" aria-label="Aclaración">
        <div className="wrap trust__row">
          <p className="trust__item">
            <span className="trust__num">$0</span>
            <span className="trust__txt">de recargo para vos</span>
          </p>
          <p className="trust__item">
            <span className="trust__num">ML</span>
            <span className="trust__txt">es quien te vende</span>
          </p>
          <p className="trust__item">
            <span className="trust__num">%</span>
            <span className="trust__txt">comisión para El buen dato</span>
          </p>
        </div>
      </section>

      <section className="datos" id="datos">
        <div className="wrap">
          <p className="eyebrow">Selección</p>
          <h2 className="datos__title">Los datos de hoy</h2>
          <p className="datos__lead">
            Cada botón abre Mercado Libre con link de afiliado. El precio, el envío y la
            garantía los define el vendedor.
          </p>
          <div className="chips" role="group" aria-label="Filtrar por categoría">
            {chips}
          </div>
          {getGrilla(tarjetas)}
        </div>
      </section>

      <section className="pasos" id="como">
        <div className="wrap">
          <p className="eyebrow">Cómo funciona</p>
          <h2 className="pasos__title">Tres pasos. Cero carrito nuestro.</h2>
          <ol className="pasos__list">
            <li className="paso">
              <span className="paso__n">1</span>
              <h3 className="paso__t">Elegí un dato</h3>
              <p className="paso__p">Leé por qué conviene y si encaja con lo que buscás.</p>
            </li>
            <li className="paso">
              <span className="paso__n">2</span>
              <h3 className="paso__t">Abrí el link</h3>
              <p className="paso__p">Te lleva a Mercado Libre. Esa URL es de afiliado.</p>
            </li>
            <li className="paso">
              <span className="paso__n">3</span>
              <h3 className="paso__t">Comprá allá</h3>
              <p className="paso__p">Pagás en Mercado Libre. Si se concreta, cobramos comisión.</p>
            </li>
          </ol>
        </div>
      </section>

      <footer className="footer">
        <div className="wrap footer__inner">
          <p className="footer__brand">
            <img alt="" className="footer__logo" src="/logo.png" />
            El buen dato
          </p>
          <p className="footer__note">
            Participamos del programa de afiliados de Mercado Libre. No somos el vendedor
            ni gestionamos el pago, el envío ni la garantía.
          </p>
        </div>
      </footer>
    </main>
  );
}
